import axios from 'axios';

export const state = () => ({
    items: []
});

export const getters = {
    items: state => state.items
};

export const mutations = {
    SET_ITEMS(state, items) {
        state.items = items;
    },

    ADD_ITEM(state, item) {
        state.items.push(item);
    },

    UPDATE_ITEM(state, updatedItem) {
        const index = state.items.findIndex(item => item.id === updatedItem.id);

        if (~index) {
            state.items.splice(index, 1, updatedItem);
        }
    },

    DELETE_ITEM(state, id) {
        const index = state.items.findIndex(item => item.id === id);

        if (~index) {
            state.items.splice(index, 1);
        }
    }
};

export const actions = {
    async index({ commit }, id) {
        const items = await axios.$get(`/alerts/${id}`);

        commit('SET_ITEMS', items);
    },

    async store({ commit }, data) {
        const alert = await axios.$post(`/alerts`, data);

        commit('ADD_ITEM', alert);
    },

    async update({ commit }, data) {
        const updatedAlert = await axios.$put(`/alerts/${data.id}`, data);

        commit('UPDATE_ITEM', updatedAlert);
    },

    async delete({ commit }, id) {
        await axios.$delete(`/alerts/${id}`);

        commit('DELETE_ITEM', id);
    },

    async toggleState({ commit }, id) {
        const updatedAlert = await axios.$post(`/alerts/${id}/toggle-state`);

        commit('UPDATE_ITEM', updatedAlert);

        return updatedAlert;
    }
};
